import Vue from 'vue';
import config from './config';
import registerRouterGuard from './registerRouterGuard';
import registerHttpInterceptors from './registerHttpInterceptors';

const auth = Vue.observable(config);

function useAuth() {
  return auth;
}

useAuth.install = function install(InnerVue, { router }) {
  registerHttpInterceptors({ router });
  registerRouterGuard({ router, auth });

  auth.init();

  InnerVue.prototype.$auth = auth;
};

export default useAuth;

export * from './utils/tokenManager';
